export default "__VITE_ASSET__BPxcS4ut__"